import registerFile from '../../../common/files/index';

import presentationalComponent from './File';
import containerComponent from './FileContainer';
import modalComponent from './modal/FileModal';

import {
    allSelectedElementsDisplayingInfo,
    labelsFeatureAndCardViewPredicate,
    noSelectedElementsInIconViewMode,
} from '../../workspace/toolbar/config/toolbarToolConfigUtils';

import { TOOLBAR_TOOLS, TOOL_SETS } from '../../workspace/toolbar/config/toolbarToolConfig';
const onlyInCardView = ({ selectedElements }) => noSelectedElementsInIconViewMode(selectedElements);

const fileCaptionTool = {
    ...TOOLBAR_TOOLS.CAPTION,
    availabilityPredicate: ({ selectedElements }) =>
        noSelectedElementsInIconViewMode(selectedElements) && allSelectedElementsDisplayingInfo(selectedElements),
};

const fileRenameToolAvailabilityPredicate = (args) => {
    const baseRenameAvailable = TOOLBAR_TOOLS.RENAME.availabilityPredicate?.(args);
    if (!baseRenameAvailable) return false;
    const { selectedElements } = args;
    return noSelectedElementsInIconViewMode(selectedElements) && allSelectedElementsDisplayingInfo(selectedElements);
};

const fileRenameTool = {
    ...TOOLBAR_TOOLS.RENAME,
    availabilityPredicate: fileRenameToolAvailabilityPredicate,
};

const fileHeadSelectedTools = [
    TOOLBAR_TOOLS.COLOR,
    {
        ...TOOLBAR_TOOLS.LABEL,
        availabilityPredicate: labelsFeatureAndCardViewPredicate,
    },
    {
        ...TOOLBAR_TOOLS.REACTION,
        availabilityPredicate: onlyInCardView,
    },
    {
        ...TOOLBAR_TOOLS.COMMENT,
        availabilityPredicate: onlyInCardView,
    },
    TOOLBAR_TOOLS.DISPLAY_MODE,
];

const fileDisplayInfoAndMediaTools = [
    TOOLBAR_TOOLS.DISPLAY_INFO,
    TOOLBAR_TOOLS.MEDIA_LOOP,
    TOOLBAR_TOOLS.MEDIA_AUTOPLAY,
];

const FILE_CORE_SELECTED_TOOLS = [...fileHeadSelectedTools, ...fileDisplayInfoAndMediaTools, fileCaptionTool];

const FILE_SELECTED_TOOLS = [
    ...fileHeadSelectedTools,
    fileRenameTool,
    fileCaptionTool,
    ...fileDisplayInfoAndMediaTools,
    ...TOOL_SETS.MULTI_SELECT_ARRANGEMENT,
];

export default () =>
    registerFile({
        containerComponent,
        presentationalComponent,
        modalComponent,
        tools: {
            selected: FILE_SELECTED_TOOLS,
            editing_TITLE: [...FILE_CORE_SELECTED_TOOLS, ...TOOL_SETS.MULTI_SELECT_ARRANGEMENT],
            editing_CAPTION: TOOL_SETS.TEXT_EDITING_CAPTION,
        },
    });
